<mat-list [formGroup]="vehiclesFormGroup">
  <mat-list-item>
    <mat-checkbox [formControl]="formControls[AircraftType.GLIDER]"
      >Glider / Motor glider</mat-checkbox
    ></mat-list-item
  >
  <mat-list-item>
    <mat-checkbox [formControl]="formControls[AircraftType.TOW_PLANE]"
      >Tow / Tug Plane</mat-checkbox
    ></mat-list-item
  >
  <mat-list-item>
    <mat-checkbox [formControl]="formControls[AircraftType.HELICOPTER]"
      >Helicopter / Rotorcraft</mat-checkbox
    ></mat-list-item
  >
  <mat-list-item>
    <mat-checkbox [formControl]="formControls[AircraftType.PARACHUTE]"
      >Parachute / Skydiver</mat-checkbox
    ></mat-list-item
  >
  <mat-list-item>
    <mat-checkbox [formControl]="formControls[AircraftType.DROP_PLANE]"
      >Drop Plane</mat-checkbox
    ></mat-list-item
  >
  <mat-list-item>
    <mat-checkbox [formControl]="formControls[AircraftType.HANG_GLIDER]"
      >Hang Glider</mat-checkbox
    ></mat-list-item
  >
  <mat-list-item>
    <mat-checkbox [formControl]="formControls[AircraftType.PARAGLIDER]"
      >Para Glider</mat-checkbox
    ></mat-list-item
  >
  <mat-list-item>
    <mat-checkbox [formControl]="formControls[AircraftType.AIRCRAFT_REC]"
      >Powered Aircraft</mat-checkbox
    ></mat-list-item
  >
  <mat-list-item>
    <mat-checkbox [formControl]="formControls[AircraftType.AIRCRAFT_JET]">Jet Aircraft</mat-checkbox></mat-list-item
  >
  <mat-list-item>
    <mat-checkbox [formControl]="formControls[AircraftType.BALLON]">Balloon</mat-checkbox></mat-list-item
  >
  <mat-list-item>
    <mat-checkbox [formControl]="formControls[AircraftType.AIRSHIP]"
      >Airship</mat-checkbox
    ></mat-list-item
  >
  <mat-list-item>

    <mat-checkbox [formControl]="formControls[AircraftType.UAV]">UAV</mat-checkbox></mat-list-item
  >
  <mat-list-item>
    <mat-checkbox [formControl]="formControls[AircraftType.UNKNOWN]">Unknown</mat-checkbox></mat-list-item
  >
  <mat-list-item>
    <mat-checkbox [formControl]="formControls.self"
      >Saját légijárművek</mat-checkbox
    ></mat-list-item
  >
</mat-list>
